import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Add IDs to addFormUrls items using url as unique identifier
 * @param {Array<AddFormUrl>} items - The items to add IDs to
 * @returns {Array<AddFormUrlWithId>} Items with IDs
 */
export const addIdsToAddFormUrls = (items) => items.map((item, index) => ({
  ...item,
  id: item.url || `add-form-${index}`,
}));

/**
 * Filter addFormUrls by search value (searches in lib only)
 * @param {Array<AddFormUrlWithId>} items - The items to filter
 * @param {string} searchValue - The search value
 * @returns {Array<AddFormUrlWithId>} Filtered items
 */
export const filterAddFormUrlsBySearch = (items, searchValue) => {
  if (!searchValue) return items;

  return items.filter((item) => stringIncludesInsensitiveAccents(item.lib, searchValue));
};
